import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import {
  formatLibradoState,
  formatLibradorState,
} from "common/mappers/mapLibrador"
import { reduce } from "lodash"
import moment from "moment"
import { handleUpdateTotalValue } from "../../components/ConceptosTable/utils/index"

const SAVE_SERIE_KEY = "last_used_serie"
const SAVE_NUMBER_KEY = "last_used_number"

export const fetchNextNumero = createAsyncThunk(
  "factura/fetchSerieAndNumero",
  async (_: $TSMigrationFixMe, { getState }: $TSMigrationFixMe) => {
    const { serie, onChangeLastAvailableNumero } = getState().newDocumento
    localStorage.setItem(
      SAVE_NUMBER_KEY,
      // @ts-expect-error TS(2345): Argument of type 'number' is not assignable to par...
      Number(localStorage.getItem(SAVE_NUMBER_KEY)) + 1
    )
    const data = await onChangeLastAvailableNumero(serie)
    return data.data
  }
)

const prepareConcepto = ({
  concepto,
  retencionPorcentaje = 0,
  descuentoPorcentaje = 0,
}: $TSMigrationFixMe) => {
  const subtotal = concepto.precioVenta * concepto.cantidad
  const descuento = subtotal * (0.01 * descuentoPorcentaje)
  const manageTotal = subtotal - descuento

  const retencion = manageTotal * 0.01 * retencionPorcentaje

  let impuesto = 0
  impuesto = manageTotal * (0.01 * concepto.impuestoArticuloPorcentaje)
  const total = subtotal + impuesto - (descuento + retencion)
  return {
    ...concepto,
    descuento,
    retencion,
    impuesto,
    subtotal,
    total,
  }
}

const getGruposImpuestos = (conceptos: $TSMigrationFixMe) => {
  return reduce(
    conceptos,
    (result, concepto) => {
      const impuestoId = concepto.impuestoArticuloTipoId

      if (impuestoId) {
        const actualValue =
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
          result[concepto.impuestoArticuloTipoId]?.totalImpuestos || 0

        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
        result[concepto.impuestoArticuloTipoId] = {
          totalImpuestos: actualValue + concepto.impuesto,
          impuestoArticuloPorcentaje: concepto.impuestoArticuloPorcentaje,
        }
      }

      return result
    },
    {}
  )
}

const initialState = {
  numero: localStorage.getItem(SAVE_NUMBER_KEY) || 1,
  serie: localStorage.getItem(SAVE_SERIE_KEY) || "F",
  fechaEmision: Date.now(),
  fechaOperacion: Date.now(),
  fechaVencimiento: Date.now(),
  documentosAsociadosId: [],
  documentosAsociados: [],
  tipoDocumentoAsociadoId: null,
  documentosAsociadosMsg: "",
  tipoDocumento: null,
  librado: null,
  librador: null,
  conceptos: [],
  conceptoToEdit: null,
  totalDescuento: 0,
  observaciones: "",
  formaPago: null,
  formaPagoDescription: "",
  formaPagoIban: "",
  formaPagoCuentaId: "",
  diasPago: null,
  descuento: 0,
  retencionTipoId: 0,
  retencionPorcentaje: 0,
  totalRetencion: 0,
  impuestoArticuloTipoId: null,
  impuestoArticuloPorcentaje: 0,
  totalImpuestos: 0,
  logo: null,
  logoName: "",
  subtotal: 0,
  gruposImpuestos: {},
  total: 0,
  comesFromMdf: false,
  isLibrado: false,
  onChangeLastAvailableNumero: null,
  joinedConceptos: [],
  intervalo: 30,
  fechaFin: null,
  fechaInicio: moment.utc(new Date()).local().format("YYYY-MM-DD"),
  id: null,
  isCompleteFacturaRecurrente: false,
  isInFacturasRecurrentes: false,
  convertNextDoc: true,
  isDocumentToContact: false,
}

export const newDocumentoSlice = createSlice({
  name: "newDocumento",
  initialState,
  reducers: {
    stateConvertirNextDoc: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      state.convertNextDoc = payload
    },
    asociateDocumentos: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      const {
        productos,
        tipoDocumentoAsociadoId,
        documentosAsociadosMsg,
        documentosAsociadosId,
        documentosAsociados,
      } = payload

      state.documentosAsociadosMsg = documentosAsociadosMsg
      state.documentosAsociados = documentosAsociados
      state.conceptos = productos
      state.tipoDocumentoAsociadoId = tipoDocumentoAsociadoId
      state.documentosAsociadosId = documentosAsociadosId
    },
    convertAsociateDocumentos: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      const {
        tipoDocumentoAsociadoId,
        documentosAsociadosMsg,
        documentosAsociadosId,
        documentosAsociados,
      } = payload

      state.documentosAsociadosMsg = documentosAsociadosMsg
      state.documentosAsociados = documentosAsociados
      state.tipoDocumentoAsociadoId = tipoDocumentoAsociadoId
      state.documentosAsociadosId = documentosAsociadosId
    },
    setLibrador: (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
      if (!payload) return
      state.librador = {
        ...payload,
        empresaContactoId: payload?.empresaContactoId || payload?.id,
      }
    },
    setLibrado: (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
      if (!payload) return
      state.librado = {
        ...payload,
        empresaContactoId: payload?.empresaContactoId || payload?.id,
      }
    },
    clearLibrado: (state: $TSMigrationFixMe) => {
      if (state.convertNextDoc) {
        state.librado = null
      }
    },
    setConceptoToEdit: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      state.conceptoToEdit = payload
    },
    addConcepto: (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
      const index = state.conceptos.findIndex(
        (con: $TSMigrationFixMe) =>
          con.id === payload.id ||
          (con.concepto === payload.concepto &&
            con.precioVenta === payload.precioVenta)
      )
      if (index === -1) {
        state.conceptos.push(prepareConcepto({ concepto: payload }))
        return
      }
      state.conceptos[index] = prepareConcepto({ concepto: payload })
    },
    deleteConcepto: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      const newConceptos = payload.conceptos.filter(
        (con: $TSMigrationFixMe) => con.id !== payload.concepto.id
      )
      state.conceptos = newConceptos
    },
    setRetencionTipoId: (
      state: $TSMigrationFixMe,
      { payload }: { payload: $TSMigrationFixMe }
    ) => {
      state.retencionTipoId = payload
    },
    setRetencionPorcentaje: (
      state: $TSMigrationFixMe,
      { payload }: { payload: $TSMigrationFixMe }
    ) => {
      state.retencionPorcentaje = payload
    },
    setDescuento: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      state.descuento = payload
    },
    recalculate: (state: $TSMigrationFixMe) => {
      const newConceptos = state.conceptos?.map(
        (concepto: $TSMigrationFixMe) => ({
          ...prepareConcepto({
            concepto,
            descuentoPorcentaje: state.descuento,
            retencionPorcentaje: state.retencionPorcentaje,
          }),
        })
      )
      state.gruposImpuestos = getGruposImpuestos(newConceptos)

      const subtotal = newConceptos?.reduce(
        (total: $TSMigrationFixMe, concepto: $TSMigrationFixMe) =>
          total + concepto.subtotal,
        0
      )

      const total = newConceptos?.reduce(
        (total: $TSMigrationFixMe, concepto: $TSMigrationFixMe) =>
          total + concepto.total,
        0
      )
      const totalRetencion = newConceptos?.reduce(
        (total: $TSMigrationFixMe, concepto: $TSMigrationFixMe) =>
          total + concepto.retencion,
        0
      )
      const totalDescuento = newConceptos?.reduce(
        (total: $TSMigrationFixMe, concepto: $TSMigrationFixMe) =>
          total + concepto.descuento,
        0
      )
      const totalImpuestos = newConceptos?.reduce(
        (total: $TSMigrationFixMe, concepto: $TSMigrationFixMe) =>
          total + concepto.impuesto,
        0
      )

      state.subtotal = subtotal
      state.total = total
      state.totalDescuento = totalDescuento
      state.totalRetencion = totalRetencion
      state.totalImpuestos = totalImpuestos
      state.conceptos = newConceptos
    },
    formatLibrado: (state: $TSMigrationFixMe) => {
      state.librado = formatLibradoState(state)
    },
    formatLibrador: (state: $TSMigrationFixMe) => {
      state.librador = formatLibradorState(state)
    },
    incrementCantidadToConcepto: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      const { articulo, sum } = payload
      const index = state.conceptos.findIndex(
        (art: $TSMigrationFixMe) => art.id === articulo.id
      )

      state.conceptos[index].cantidad += sum
    },
    setCantidad: (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
      const { articulo, cantidad } = payload
      const index = state.conceptos.findIndex(
        (art: $TSMigrationFixMe) => art.id === articulo.id
      )

      state.conceptos[index].cantidad = cantidad
    },
    setSerieAndNumero: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      localStorage.setItem(SAVE_SERIE_KEY, payload.serie)
      localStorage.setItem(SAVE_NUMBER_KEY, payload.numero)

      state.serie = payload.serie
      state.numero = payload.numero
    },
    setFechaEmision: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      state.fechaEmision = payload
    },
    setFechaOperacion: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      state.fechaOperacion = payload
    },
    setFechaVencimiento: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      state.fechaVencimiento = payload
    },
    setObservaciones: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      state.observaciones = payload
    },
    setDiasPago: (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
      state.diasPago = payload
    },
    updateLogo: (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
      state.logo = payload.logo
    },
    updateFormaPago: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      state.formaPago = payload.formaPago
      state.formaPagoIban = payload.formaPagoIban
      state.formaPagoCuentaId = payload.formaPagoCuentaId
    },
    deleteFormaPagoIban: (state: $TSMigrationFixMe) => {
      state.formaPagoIban = ""
      state.formaPagoCuentaId = ""
    },
    changeLibradoEmail(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.librado.email = payload
    },
    changeLibradorEmail(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.librador.email = payload
    },
    clearFacturaForm: (state: $TSMigrationFixMe) => {
      return {
        ...initialState,
        librador: state.librador,
        serie: localStorage.getItem(SAVE_SERIE_KEY) || "F",
        numero: localStorage.getItem(SAVE_NUMBER_KEY) || 1,
      }
    },
    setComesFromMdf(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.comesFromMdf = payload
    },
    // @ts-expect-error TS(7030): Not all code paths return a value.
    clearNewDocumentoState(state: $TSMigrationFixMe) {
      if (state.convertNextDoc) {
        return {
          ...initialState,
          tipoDocumento: state.tipoDocumento,
          serie: state.serie,
          numero: state.numero + 1,
          librador: state.librador,
          isLibrado: state.isLibrado,
          librado: state.librado,
          onChangeLastAvailableNumero: state.onChangeLastAvailableNumero,
        }
      }
    },
    setAmILibrado(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.isLibrado = payload
    },
    setDocumentToContact(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.isDocumentToContact = payload
    },
    setOnChangeLastAvailableNumero(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.onChangeLastAvailableNumero = payload
    },
    setTipoDocumento(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.tipoDocumento = payload
    },
    replaceConcepto(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      const index = state.conceptos.findIndex(
        (concepto: $TSMigrationFixMe) => concepto.id === payload.id
      )
      const updatedSubtotal = handleUpdateTotalValue(payload, payload.cantidad)
      state.conceptos[index] = {
        ...payload,
        ...{ subtotal: updatedSubtotal },
      }
    },
    setConceptos(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.conceptos = payload
    },
    setFacturaRecurrenteItems: (
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) => {
      state.intervalo = payload.intervalo
      state.fechaFin = payload.fechaFin
      state.fechaInicio = payload.fechaInicio
      state.serie = payload.serie
    },
    setIdToEdit(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.id = payload
    },
    setIsCompleteFacturaRecurrente(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.isCompleteFacturaRecurrente = payload
    },
    setIsInFacturasRecurrentes(state: $TSMigrationFixMe) {
      state.isInFacturasRecurrentes = true
    },
    setNextDocumentConvert(state: $TSMigrationFixMe) {
      sessionStorage.setItem(
        "toNextDoc",
        JSON.stringify({
          newDocument: state,
        })
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNextNumero.fulfilled, (state, { payload }) => {
      state.numero = payload
    })
  },
})

export const {
  clearLibrado,
  asociateDocumentos,
  convertAsociateDocumentos,
  clearFacturaForm,
  setLibrador,
  setLibrado,
  setConceptoToEdit,
  addConcepto,
  deleteConcepto,
  recalculate,
  setRetencionTipoId,
  setRetencionPorcentaje,
  setDescuento,
  setSerieAndNumero,
  setFechaEmision,
  setFechaOperacion,
  setFechaVencimiento,
  setObservaciones,
  updateLogo,
  setDiasPago,
  updateFormaPago,
  deleteFormaPagoIban,
  setComesFromMdf,
  changeLibradoEmail,
  clearNewDocumentoState,
  setAmILibrado,
  changeLibradorEmail,
  setOnChangeLastAvailableNumero,
  incrementCantidadToConcepto,
  setCantidad,
  setTipoDocumento,
  replaceConcepto,
  setConceptos,
  setFacturaRecurrenteItems,
  setIdToEdit,
  setIsCompleteFacturaRecurrente,
  setIsInFacturasRecurrentes,
  formatLibrado,
  formatLibrador,
  setNextDocumentConvert,
  stateConvertirNextDoc,
  setDocumentToContact,
} = newDocumentoSlice.actions

export const newDocumentoSelectorDoc = (state: $TSMigrationFixMe) =>
  state.newDocumento

export const readyToCreateDocumentoSelector = (state: $TSMigrationFixMe) => {
  if (state.newDocumento.isInFacturasRecurrentes) {
    return (
      state.newDocumento?.conceptos?.length &&
      state.newDocumento?.librado &&
      state.newDocumento?.isCompleteFacturaRecurrente
    )
  }
  return state.newDocumento?.conceptos?.length && state.newDocumento?.librado
}

export const serieDocumentoSelector = (state: $TSMigrationFixMe) =>
  localStorage.getItem(SAVE_SERIE_KEY) || state.newDocumento?.serie

export const numeroDocumentoSelector = (state: $TSMigrationFixMe) =>
  Number(localStorage.getItem(SAVE_NUMBER_KEY)) || state.newDocumento?.numero
